export function submissionStatus(s) {
    if (s == null)
        return "N/A";
    if (s.evaluated == 0)
        return "in progress...";
    if (s.success == 1)
        return "success";
    return "failed";
}
